import { cn } from '@/renderer/lib/utils';
import { AlertTypes, CardStyleDefinition } from '@/renderer/types/alerts';
import React from 'react';
import { Link } from 'react-router-dom';

const cardStyles: Record<AlertTypes, CardStyleDefinition> = {
  info: {
    cardBg:
      'rounded-xl border border-blue-200 bg-blue-50 px-5 py-4 text-lg text-blue-900',
    descriptionText: 'text-blue-800',
    buttonStyle:
      'inline-flex rounded-full bg-blue-600 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white',
    infoText: 'text-blue-800',
  },
  warning: {
    cardBg:
      'rounded-xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-900',
    descriptionText: 'text-amber-800',
    buttonStyle:
      'inline-flex rounded-full bg-amber-500 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white',
    infoText: 'text-amber-800',
  },
  error: {
    cardBg:
      'rounded-xl border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-900',
    descriptionText: 'text-red-800',
    buttonStyle:
      'inline-flex rounded-full bg-red-600 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white',
    infoText: 'text-red-800',
  },
  success: {
    cardBg:
      'rounded-xl border border-pos-secondary bg-pos-primary px-5 py-4 text-sm text-white',
    descriptionText: 'text-white',
    buttonStyle:
      'inline-flex rounded-full bg-primary-600 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white',
    infoText: 'text-gray-800',
  },
};

interface AlertCardProps {
  type?: AlertTypes;
  title: string;
  description: string;
  info?: string;
  buttonText?: string;
  buttonLink?: string;
}

export const AlertCard: React.FC<AlertCardProps> = ({
  type = AlertTypes.warning,
  title,
  description,
  info = '',
  buttonLink,
  buttonText,
}) => {
  const cardStyle = cardStyles[type];

  return (
    <div className={cn('w-full flex-col gap-4', cardStyle.cardBg)}>
      <h3 className="text-base font-semibold">{title}</h3>
      <div className={cardStyle.descriptionText}>{description}</div>
      {info ? <div className={cardStyle.infoText}>{info}</div> : null}
      {buttonLink && buttonText ? (
        <Link to={buttonLink} className={cardStyle.buttonStyle}>
          {buttonText}
        </Link>
      ) : null}
    </div>
  );
};
